import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/layout component/Login.vue'
import Login2 from '../components/layout component/Login2.vue'

import Layout from '../components/layout component/Layout.vue'
import Processes from '../views/Processes.vue'
import ListaPersonalExtra from '../views/ListaPersonalExtra.vue'
import ListaSalvo from '../views/ListaDeSalvo.vue'
import ListaIngreso from '../views/ListaIngreso.vue'
import Formulario from '../components/Formulario.vue'
import SalvoEx from '../components/FormularioEx.vue'
import Certificado from '../components/Certificado.vue'

import MenuJF from '../components/MenuJF'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  ,
  {
    path: '/login',
    name: 'login',
    component: Login,
  },

  {
    path: '/loginCert',
    name: 'loginCert',
    component: Login2,
  },

  {
    path: '/layout',
    name: 'layout',
    component: Layout,
    redirect: '/lista-usuarios',
    children: [{
      path: '/lista-usuarios',
      name: 'Processes',
      component: Processes,
       beforeEnter: (to, from, next) => {
        if (router.app.$session.getAll().typeUser == 'Admin') next()
        else next({ name: 'formulario' })
      } 
    },


    {
      path: '/lista-ingreso',
      name: 'Ingreso',
      component: ListaIngreso,
      beforeEnter: (to, from, next) => {
        if (router.app.$session.getAll().typeUser == 'Admin') next()
        else next({ name: 'formulario' })
      }
    },

    {
      path: '/lista-personal-extra',
      name: 'PersonalExtra',
      component: ListaPersonalExtra,
      beforeEnter: (to, from, next) => {
        if (router.app.$session.getAll().typeUser == 'Admin') next()
        else next({ name: 'formulario' })
      }
    },

    {
      path: '/lista-salvoconducto',
      name: 'SalvoList',
      component: ListaSalvo,
       beforeEnter: (to, from, next) => {
        if (router.app.$session.getAll().typeUser == 'Admin') next()
        else next({ name: 'formulario' })
      } 
    },

    {
      path: '/lista-salvoconducto-activos',
      name: 'SalvoList',
      component: ListaSalvo,
       beforeEnter: (to, from, next) => {
        if (router.app.$session.getAll().typeUser == 'Admin') next()
        else next({ name: 'formulario' })
      } 
    },

    {
      path: '/lista-ingreso-historico',
      name: 'Historico',
      component: ListaIngreso,
      beforeEnter: (to, from, next) => {
        if (router.app.$session.getAll().typeUser == 'Admin') next()
        else next({ name: 'formulario' })
      }
    },
    {
      path: '/formulario',
      name: 'formulario',
      component: Formulario,
    },
    {
      path: '/formularioEx',
      name: 'formularioEx',
      component: SalvoEx,
    },
    {
      path: '/certificado',
      name: 'certificado',
      component: Certificado,
    },
    {
      path: '/menu',
      name: 'menu',
      component: MenuJF,
       beforeEnter: (to, from, next) => {
        if (router.app.$session.getAll().typeUser == 'Admin') next()
        else next({ name: 'formulario' })
      } 
    }
    ]
  }


]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && !router.app.$session.exists()) next({ name: 'login' })
  else next()
})



export default router
